import axios from "axios";

export const state = {
    shares: [],
};

export const getters = {
    shares: (state) => state.shares,
};

export const mutations = {
    setShares(state, newValue) {
        state.shares = newValue;
    },
};

export const actions = {
    async fetchShares({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/shares/${fyear}`).then((res) => {
            commit("setShares", res.data.shares);
        });
    },
    async filterShares({ commit }, { datefrom, dateto }) {
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filtershares";
        await axios.post(url, formData).then((response) => {
            commit("setShares", response.data.shares);
        });
    },
};
